import axios from 'axios'
import { ContainerModule } from 'inversify'
import { RequestInterceptor, ResponseInterceptor } from '@kibsi/ks-client-sdk'
import { Environment } from 'config/environment'
import T from 'config/inversify.types'

import { createKibsiApiClient } from './kibsi.api'
import { KibsiAuthConfigProvider } from './kibsi.auth.config'
import { requestHandler } from './request.handler'
import { errorHandler } from './error.handler'

const Api = {
    onRequest: Symbol('onRequest'),
    onResponse: Symbol('onResponse'),
}

export const KibsiApiModule = new ContainerModule((bind) => {
    bind(Api.onRequest).toDynamicValue(({ container }) => {
        const config = container.get<KibsiAuthConfigProvider>(T.KibsiApiConfig)
        return requestHandler(config)
    })

    bind(Api.onResponse).toDynamicValue(() => errorHandler())

    bind(T.KibsiApiConfig).to(KibsiAuthConfigProvider).inSingletonScope()
    bind(T.KibsiApi).toDynamicValue(({ container }) => {
        const env = container.get<Environment>(T.Environment)
        const onRequest = container.get<RequestInterceptor>(Api.onRequest)
        const onResponse = container.get<ResponseInterceptor>(Api.onResponse)

        return createKibsiApiClient(env, {
            interceptors: {
                request: [onRequest],
                response: [onResponse],
            },
        })
    })

    bind(T.Http).toDynamicValue(({ container }) => {
        const onRequest = container.get<RequestInterceptor>(Api.onRequest)
        const onResponse = container.get<ResponseInterceptor>(Api.onResponse)

        const http = axios.create({})
        http.interceptors.request.use(...onRequest)
        http.interceptors.response.use(...onResponse)

        return http
    })
})
